import { FormGroup } from '@angular/forms';

export function toSortExpression(event: Event, excludedColumn: string): string | null {
  const { column, direction } = (event as CustomEvent).detail;
  if (column === excludedColumn) {
    return null;
  }

  const sortDirection = direction === 'ascending' ? 'asc' : 'desc';
  return `${column}:${sortDirection}`;
}

export function readNonEmptyStringArray(form: FormGroup, controlName: string): string[] | null {
  const value = form.get(controlName)?.value as string[] | null;
  return value?.length ? value : null;
}

export function navigationSegments(basePath: string, row: { repairCode: string; repairMode: string }, action?: string): string[] {
  const segments = [basePath, row.repairMode, row.repairCode];
  return action ? [...segments, action] : segments;
}
